import {useMemo} from 'react';
import * as Yup from 'yup';

import useIsLoggedIn from '../../../../hooks/useIsLoggedIn';
import {useStores} from '../../../../stores/use-stores';

// Just trying to refactor things out of those platform-dependent
// CardTokeniserTill.tsx files looking to one day unify them as
// we have done with others.

const CardTokeniserTillSchema = Yup.object().shape({
  cardHolder: Yup.string().required("Cardholder's name is required").nullable(),
  number: Yup.string().defined().required('Required').nullable(),
  cvv: Yup.string().defined().required('Required').nullable(),
  month: Yup.number()
    .min(1)
    .max(12)
    .typeError('Invalid number')
    .required('Required')
    .nullable(),
  year: Yup.number()
    .typeError('Invalid number')
    .required('Required')
    .nullable(),
});

export type CardTokeniserTillValues = Yup.InferType<
  typeof CardTokeniserTillSchema
>;

export const useCardTokeniserTillSchemaDefaultValues = () => {
  const {userStore} = useStores();
  const isLoggedIn = useIsLoggedIn();

  const cardholder = useMemo(
    () => (isLoggedIn ? `${userStore.firstName} ${userStore.lastName}` : null),
    [isLoggedIn, userStore.firstName, userStore.lastName],
  );

  const defaultValues = {
    cardHolder: cardholder,
    number: null,
    cvv: null,
    month: '',
    year: '',
  };

  return defaultValues;
};

export default CardTokeniserTillSchema;
